import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { getUserId } from '../../../../../helpers/cookies';
import { appShapes } from 'App/duck';
import styled from './styled';
import {
  ChannelMessageWrap,
  Info,
  ActionMenuWrap,
  ContextMenu,
} from '../styled';
import Icon from './Icon';
import { messageDateFormat } from 'helpers/date-time';
import { Mixpanel } from 'helpers/Mixpanel';
import GenericConfirmActionModal from 'pages/CommunityMergeFeed/CreateFeed/GenericConfirmActionModal';

class ChannelComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: null,
      showLeaveModal: false,
      receiveNewPost: false,
    };

    this._isMounted = false;
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    const { locations, locationId, } = this.props;

    this._isMounted = true;
    if (locations && locations.length > 0) {
      const currentLocation = locations.filter((location) => location.id === parseInt(locationId));
      if (currentLocation && currentLocation.length > 0) {
        this.setState({ location: currentLocation[0] });
      }
    }
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleEscapePress);
  }

  componentDidUpdate(prevProps, prevState) {
    const { active, channel, handleClick, location, locations, locationId, } = this.props;

    if (prevProps.locations !== locations) {
      if (locations && locations.length > 0) {
        const currentLocation = locations.filter((location) => location.id === parseInt(locationId));
        if (currentLocation && currentLocation.length > 0) {
          this.setState({ location: currentLocation[0] });
        }
      }
    }

    if (prevProps.channel !== channel) {
      if (channel && channel.receiveNewPost && channel.receiveNewPost === true) {
        this.setState({ receiveNewPost: true });
      } else {
        this.setState({ receiveNewPost: false });
      }
    }

  }

  componentWillUnmount() {

    this._isMounted = false;
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscapePress);
  }


  handleClickOutside = (event) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ showMenuFor: null });
    }
  };

  handleEscapePress = (event) => {
    if (event.key === 'Escape') {
      this.setState({ showMenuFor: null });
    }
  };

  toggleModal = (key, value) => {
    this.setState({ [key]: value });
  };

  handleLeaveChannel = () => {
    const { channel } = this.props;

    this.props.onDelete?.(channel.id)
    this.toggleModal('showLeaveModal', false);
  };

  render() {
    const { active, channel, handleClick, } = this.props;
    const { location, receiveNewPost, showLeaveModal } = this.state;
    const channelName = channel?.channel_name || '';
    let avatarUrl = '';
    if (channel.channel_type === 'location_feed') {
      if (location && location.avatar_blob) {
        avatarUrl = location.avatar_blob.blob_url;
      } else {
        avatarUrl = '/icons/channel avatar.svg';
      }
    } else if (channel.channel_type === 'custom_feed') {
      if (channel.shyft_channel) {
        avatarUrl = '/icons/favicon.ico';
      } else {
        avatarUrl = '/icons/channel avatar.svg';
      }
    } else if (channel.channel_type === 'region_feed') {
      avatarUrl = '/icons/channel avatar.svg';
    }

    const approvedBadge = '/icons/verified-badge-icon.svg';
    const condition = false;

    const dateTimeInfo = messageDateFormat(channel.updated_at);
    let lastContent = '';
    if (channel && channel.channel_latest_content) {
      if (channel.channel_latest_content.length > 3) {
        lastContent = channel.channel_latest_content;
      }
    }

    return (
      <ChannelMessageWrap
        modifiers={active ? 'active' : null}
        onClick={() => {
          handleClick(channel.id);
          Mixpanel.track('Click channel feed', { 'channel_id': channel.id });
        }}
      >
        <styled.ChannelAvatar src={avatarUrl} />

        <ActionMenuWrap
          ref={this.wrapperRef}
          className={this.state.showMenuFor === channel.id ? 'menu-open' : ''}
          alwaysVisible={this.state.showMenuFor === channel.id}
          onClick={(e) => {
            e.stopPropagation();
            this.setState((prevState) => ({
              showMenuFor: prevState.showMenuFor === channel.id ? null : channel.id
            }));
          }}
        >
          <img src="/icons/ellipses-icon-h.svg" alt="More" />
          {this.state.showMenuFor === channel.id && (
            <ContextMenu>
              {/* <div onClick={() => this.props.onMute?.(channel.id)}>Mute session</div> */}
              <div onClick={() => this.toggleModal('showLeaveModal', true)}>Leave Channel</div>
            </ContextMenu>
          )}
        </ActionMenuWrap>

        <Info>
          <styled.TopLineWrap>
            <styled.Name>{channel ? channel.channel_name : ''}</styled.Name>
            {condition && <styled.ApprovedBadge src={approvedBadge} />}
            <styled.Time>{dateTimeInfo}</styled.Time>
          </styled.TopLineWrap>
          <styled.BottomLineWrap>
            <styled.LatestContent>{lastContent}</styled.LatestContent>
            {receiveNewPost && <styled.NewPostIndicator />}
          </styled.BottomLineWrap>
        </Info>

        {showLeaveModal && (
          <GenericConfirmActionModal
            title={<FormattedMessage id="PostComponent.leaveGroup" defaultMessage="Leave Group?" />}
            message={
              <FormattedMessage
                id="PostComponent.confirmLeaveContent"
                defaultMessage="Are you sure you want to leave {group}"
                values={{ group: channelName }}
              />
            }
            confirmLabel="Leave Group"
            actionType="leave"
            onCancel={() => this.toggleModal('showLeaveModal', false)}
            onConfirm={this.handleLeaveChannel}
          />
        )}
      </ChannelMessageWrap>
    );
  }
}

ChannelComponent.propTypes = {
  //fetchPosts: PropTypes.func.isRequired,

};

export default injectIntl(ChannelComponent);



